import {ApiId, DistributionAccountModel} from '../distribution-account/distribution-account.model';

/**
 * Represents the Target-System in which segments can be shared. Primarily used for inbound and outbound communication.
 */
export class TargetSystemModel {
  // do not mix this IO model with any view flags.

  /** the identifier of this target system */
  id!: number;
  name!: string;
  /**
   * If true, a user provides a foreign account id for a
   * distribution account linked to this target system.
   */
  userProvidedForeignId!: boolean;
  distributionAccounts?: DistributionAccountModel[];
  apiId: ApiId = ApiId.DEFAULT;

  constructor(fields: {
    id: number,
    name: string,
    userProvidedForeignId: boolean,
    distributionAccounts?: DistributionAccountModel[]
  }) {

    if (fields) {
      Object.assign(this, fields);
      if (this.distributionAccounts) {
        this.distributionAccounts = DistributionAccountModel.fromList(this.distributionAccounts);
      } else {
        this.distributionAccounts = [];
      }
    }
  }

  static from(object: any): TargetSystemModel {
    return new TargetSystemModel(object);
  }

  static fromList(objects: any[]): TargetSystemModel[] {
    return objects.map(TargetSystemModel.from);
  }
}

/**
 * List of active target systems (segment sharing enabled).
 * @see com.emetriq.segments.distribution.clients.SegmentMappingBrokerImpl
 */
export const ACTIVE_TARGET_SYSTEMS: number[] = [1, 5, 6, 8, 10, 25];
